import { View, ScrollView } from "react-native"
import { BackStackNavHeader } from "./BackStackNavHeader"
import { CustomHeader } from "./CustomHeader"
import { Loading } from "@shared/components/loading"
import { KeyboardAvoidingView } from "react-native"
import { Platform } from "react-native"
import React from "react"
import { useSafeAreaInsets } from "react-native-safe-area-context"

function useBottomPadding() {
    const insets = useSafeAreaInsets();
    return insets.bottom;
}

export const MainLayout = ({
    children,
    title,
    backText,
    showBackText,
    navigation,
    backIcon,
    isLoading,
    scrollable = false
}: {
    children: React.ReactNode,
    title?: string,
    backText?: string,
    showBackText?: boolean,
    navigation?: () => void,
    backIcon?: 'left' | 'close',
    isLoading?: boolean,
    scrollable?: boolean
}) => {
    const bottomPadding = useBottomPadding();

    return (
        <KeyboardAvoidingView
            behavior={Platform.OS === "ios" ? "padding" : "height"}
            style={{ flex: 1 }}
        >
            <View className="flex-1 bg-white" style={scrollable ? undefined : { paddingBottom: bottomPadding }}>
                {navigation ? (
                    <BackStackNavHeader title={title} backText={backText} showBackText={showBackText} customNavigation={navigation} backIcon={backIcon} />
                ) : title ? (
                    <CustomHeader title={title} className='px-8' />
                ) : null}
                {isLoading ? (
                    <View className='px-8 flex-1'>
                        <Loading />
                    </View>
                ) : scrollable ? (
                    <ScrollView
                        className="flex-1 px-8"
                        contentContainerStyle={{ flexGrow: 1, paddingBottom: bottomPadding + 32 }}
                        keyboardShouldPersistTaps='handled'
                    >
                        {children}
                    </ScrollView>
                ) : (
                    <View className='px-8 flex-1'>
                        {children}
                    </View>
                )}
            </View>
        </KeyboardAvoidingView>
    )
}